export default "__VITE_ASSET__c571d517__"